const testimonials = [
  {
    name: "Barbara K.",
    location: "Boynton Beach, FL",
    rating: 5,
    text: "My husband and I are snowbirds from New Jersey, and we had a Mediterranean cruise booked out of Barcelona in six weeks. I pulled our passports out of the safe to make copies for the travel agent and discovered his had expired four months ago. We panicked. Fast Passport Center handled everything — we shipped from the FedEx on Federal Highway on Monday, and both passports were back within five business days. Our cruise is saved, and we didn't have to drive to Miami or wait in any lines.",
    service: "Passport Renewal",
  },
  {
    name: "Michael R.",
    location: "Boynton Beach, FL",
    rating: 5,
    text: "I work in pharmaceutical sales and cover the Southeast region from my home office in Boynton Beach. I got word of a product launch in Mexico City with nine days notice — and my passport had expired two months prior. Fast Passport Center got me processed and back in three business days. I made the launch, closed the deal, and my manager still doesn't know how close it was. Shipping from the UPS Store on Ocean Avenue was simple.",
    service: "Passport Renewal",
  },
  {
    name: "The Cohen Family",
    location: "Boynton Beach, FL",
    rating: 5,
    text: "Our daughter's bat mitzvah group trip to Israel was planned for over a year. Three weeks before departure, we discovered her passport had expired six months earlier — she had turned 16 and her child passport was no longer valid. Fast Passport Center walked us through the adult passport process, we shipped her documents overnight from the FedEx on Boynton Beach Boulevard, and her new passport arrived in four days. Twelve families were counting on us, and Fast Passport Center saved the entire trip.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BoyntonBeachTestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Boynton Beach Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Boynton Beach, Ocean Ridge, Gulf Stream, and southern Palm Beach County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}